// extracted by mini-css-extract-plugin
module.exports = {"root":"styles_root__1Ze-G","badges":"styles_badges__18a31"};